import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import styled from 'styled-components';
import { I18N } from 'commons';
import v from 'scss/v';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  label {
    line-height: 1.75rem;
    font-weight: normal;
  }
`;

const SlackOptionsSection = ({
  values: { sendSlack },
  slackMandatory,
  setFieldValue,
  setFieldTouched,
  SlackMandatory,
  SlackEditable,
  SlackExposed,
}) => (
  <Container className="col-md-8">
    {SlackExposed && (
      <label className="pl-3">
        <Field
          name="sendSlack"
          value={(sendSlack)}
          className="form-control"
          render={({ field }) => (
            <input
              type="checkbox"
              checked={field.value}
              onChange={() => {
                setFieldValue('sendSlack', !sendSlack);
                setFieldTouched('slackField', true);
              }}
              disabled={SlackEditable}
            />
          )}
        />
        {
          (!slackMandatory || SlackMandatory) &&
          <span aria-hidden="true" className="required-star">*</span>
        }
        <I18N>new.registration.signup.create.account.label.sendSms</I18N>
        {
          (!slackMandatory || SlackMandatory) &&
          <span className="sr-only"><I18N>information.label.required</I18N></span>
        }
      </label>
    )}
  </Container>
);

SlackOptionsSection.propTypes = {
  values: PropTypes.shape().isRequired,
  SlackMandatory: PropTypes.bool.isRequired,
  slackMandatory: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  SlackEditable: PropTypes.bool.isRequired,
  SlackExposed: PropTypes.bool.isRequired,
};

export default SlackOptionsSection;
